import { Action } from '@ngrx/store';
import { Menu } from '@shared/models/menu.model';

export enum MenuActionTypes {
  MenuRequested = '[Menu] User Menu Requested',
  MenuLoaded = '[Menu] User Menu Loaded',
  MenuUpdated = '[Menu] User Menu Updated',
  ResetMenu = '[Menu] Reset Menu '
}

export class MenuRequestedAction implements Action {
  readonly type = MenuActionTypes.MenuRequested;
  constructor(public payload: string[]) {}
}

export class MenuLoadedAction implements Action {
  readonly type = MenuActionTypes.MenuLoaded;
  constructor(public payload: Menu[]) {}
}

export class MenuUpdatedAction implements Action {
  readonly type = MenuActionTypes.MenuUpdated;
  constructor(public payload: Menu) {}
}

export class ResetMenuAction implements Action {
  readonly type = MenuActionTypes.ResetMenu;
  constructor() {}
}

export type MenuActions = MenuRequestedAction | MenuLoadedAction | MenuUpdatedAction | ResetMenuAction;
